import makeStyles from '@mui/styles/makeStyles';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CopyToClipboardBannerStyles from './CopyToClipboardBanner.styles';
import Copy from 'react-feather/dist/icons/copy';
import X from 'react-feather/dist/icons/x';
import { copyAsCSV, getAssetIdFromPath } from '../../../utils/utils';
import { CONSTANTS } from '../../../constants/constants';
import NRRemediateIcon from '../../../NRIcons/NRRemediateIcon';
import React, { useContext, useEffect, useState } from 'react';
import { RemediationContext } from '../../NRRemediation/NRRemediationContext';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { GridContext } from '../../NRReactGrid/NRReactGridContext';
import { useSnackbar } from 'notistack';
import FileDownloadComponent from '../../NRCertTable/CertTableCustomComponents/FileDownloadComponent';
import NRGroupIcon from '../../../NRIcons/NRGroupIcon';
import NRRemoveGroupsIcon from '../../../NRIcons/NRRemoveGroupsIcon';
import { AssetGroupContext } from '../../AssetGroup/assetGroupContextWrapper';
import { SBOMContext } from '../../../pages/NRSBOMTable/NRSBOMDataShare';
import useHasPermission from '../../Permissions/useHasPermission';
import { useLocation, useParams } from 'react-router-dom';
import NRSelectAll from '../NRSelectAll/NRSelectAll';
import WithPermissions from '../../Permissions/WithPermissions';
import { SBOM_CONSTANTS } from '../../SBOM/SBOM.constants';
import NRRemediationContent from '../../NRRemediation/NRRemediationContent/NRRemediationContent';
import NRLicenseIssueRemediationContent from '../../NRRemediation/NRLicenseIssueRemediation/NRLicenseIssueRemediationContent';

const { ITEM_SELECTED, ITEMS_SELECTED, TOOLTIP_COPY_CSV, ADD_TO_GROUPS, REMOVE_FROM_GROUPS, TOOLTIP_UNSELECT, TOOLTIP_REMEDIATE, TOOLTIP_DOWNLOAD } =
  CONSTANTS.TABLE.COPY_TO_CLIPBOARD_BANNER;
const {
  VULNERABILITIES: VULNERABILITIES_TAB,
  FILE_SYSTEM: FILE_SYSTEM_TAB,
  SBOM: SBOM_TAB,
  LICENSE_ISSUES: LICENSE_ISSUES_TAB
} = CONSTANTS.REPORT.TABS;

const useStyles = makeStyles(CopyToClipboardBannerStyles);

const addToGroupsValidPaths = ['/assets'];

function CopyToClipboardBanner({ selectedItems, setSelection, rows, totalCount, showSelectAllItems, selectAllFetchConfig }) {
  const { setOpenRemediationModal, setCVEs, setRemediateAllVulnerabilitiesFilter, setContent, setTitle } = useContext(RemediationContext);
  const { setShouldClearSelection } = useContext(GridContext);
  const { enqueueSnackbar } = useSnackbar();
  const [filesToDownload, setFilesToDownload] = useState();
  const [disableDownload, setDisableDownload] = useState(false);
  const [allItems, setAllItems] = useState([]);
  const theme = useTheme();
  const { setSelectedAssets, setShowManageGroupsAddBulkModal, setShowManageGroupsRemoveAllModal } = useContext(AssetGroupContext);
  const { setOpenRemoveModal, setSelectedComponents } = useContext(SBOMContext);
  const canWriteGroups = useHasPermission({ permission: CONSTANTS.PERMISSIONS.WRITE_GROUPS });
  const canWriteAsset = useHasPermission({ permission: CONSTANTS.PERMISSIONS.WRITE_IMGS });
  const location = useLocation();
  const { tab } = useParams();
  const pathname = location.pathname;
  const showAddToGroupOptions = addToGroupsValidPaths.includes(pathname);
  const classes = useStyles();

  const handleRemediationClick = () => {
    if (tab === VULNERABILITIES_TAB) {
      let cvesToRemediate = !!allItems.length ? allItems : selectedItems.map(item => rows[item]);
      setCVEs(cvesToRemediate);
      if (!!allItems.length && selectAllFetchConfig?.qlArgs) {
        setRemediateAllVulnerabilitiesFilter(selectAllFetchConfig?.qlArgs);
      }
      setTitle(`Remediate issues - ${cvesToRemediate?.length}`);
      setContent(<NRRemediationContent />);
    } else if (tab === LICENSE_ISSUES_TAB) {
      let licensesToRemediate = !!allItems.length ? allItems : selectedItems.map(item => rows[item]);
      /*setCVEs(licensesToRemediate);
      if (!!allItems.length && selectAllFetchConfig?.qlArgs) {
        setRemediateAllVulnerabilitiesFilter(selectAllFetchConfig?.qlArgs);
      }*/
      setTitle(`Remediate issues - ${licensesToRemediate?.length}`);
      setContent(<NRLicenseIssueRemediationContent licenseIssues={licensesToRemediate} />);
    }
    setOpenRemediationModal(true);
  };

  const handleAddToGroupsClick = () => {
    let assetsToAdd = !!allItems.length ? allItems : rows.filter((e, index) => selectedItems.includes(index));
    setSelectedAssets(assetsToAdd);
    setShowManageGroupsAddBulkModal(true);
  };

  let assetId = getAssetIdFromPath();

  useEffect(() => {
    return () => setFilesToDownload(null);
  }, []);

  useEffect(() => {
    if (tab === FILE_SYSTEM_TAB) {
      handleBulkDownload();
    }
  }, [selectedItems]);

  const handleBulkDownload = () => {
    let toReturn = selectedItems.map(item => ({ path: rows[item]?.path }));
    setDisableDownload(selectedItems.some(item => !rows[item]?.canDownload));
    setFilesToDownload(toReturn);
  };

  async function handleCopyCsvClick() {
    copyAsCSV(selectedItems.map(item => rows[item]));
    enqueueSnackbar(CONSTANTS.COPIED_TO_CLIPBOARD_MSG, { variant: 'success' });
    setShouldClearSelection(true);
  }

  function getIdentificationsFromDependencies(data) {
    if (!Array.isArray(data)) {
      return [];
    }

    const identificationsArray = data.flatMap(item => {
      if (item?.dependency?.type === SBOM_CONSTANTS.COMPONENT_TYPE.ROOT) {
        return [];
      }
      return item?.dependency?.identificationIds || [];
    });

    return identificationsArray;
  }

  const handleRemoveComponentsClick = () => {
    const selectedRows = rows.filter((e, index) => selectedItems.includes(index));
    const identificationIds = getIdentificationsFromDependencies(selectedRows);
    const combinedComponents = { assetId, identificationIds, count: selectedRows?.length };

    setSelectedComponents(combinedComponents);
    setOpenRemoveModal(true);
  };

  return (
    <div className={classes.mainContainer}>
      {!allItems.length && (
        <div className={classes.title}>
          {selectedItems.length + ' '}
          {selectedItems.length > 1 ? ITEMS_SELECTED : ITEM_SELECTED}
        </div>
      )}
      {!!allItems.length && (
        <div className={classes.title}>
          {allItems.length > 1 ? 'All ' : ''}
          {allItems.length + ' '}
          {allItems.length > 1 ? ITEMS_SELECTED.toLowerCase() : ITEM_SELECTED.toLowerCase()}
        </div>
      )}
      {!!selectAllFetchConfig && showSelectAllItems && showAddToGroupOptions && (
        <NRSelectAll allItems={allItems} setAllItems={setAllItems} itemsCount={totalCount} {...selectAllFetchConfig} />
      )}
      <div className={classes.actions}>
        {(tab === VULNERABILITIES_TAB || tab === LICENSE_ISSUES_TAB) && (
          <WithPermissions permission={CONSTANTS.PERMISSIONS.WRITE_IMGS}>
            <Tooltip title={TOOLTIP_REMEDIATE}>
              <IconButton aria-label="Remediate items" component="span" color="inherit" size="small" onClick={handleRemediationClick}>
                <NRRemediateIcon color={theme.palette.secondary.contrastText} />
                <Typography variant={'subtitle2'} color={theme.palette.secondary.contrastText} sx={{ ml: 1, mr: 1 }}>
                  Remediate
                </Typography>
              </IconButton>
            </Tooltip>
          </WithPermissions>
        )}
        {tab === FILE_SYSTEM_TAB && (
          <>
            <FileDownloadComponent
              componentId={assetId}
              fileList={filesToDownload}
              cursorPointer={true}
              tooltipTitle={TOOLTIP_DOWNLOAD}
              color={theme.palette.secondary.contrastText}
              showButtonComponent={true}
              afterDownloadAction={() => setShouldClearSelection(true)}
              disabled={disableDownload}
            />
          </>
        )}
        {!!canWriteGroups && showAddToGroupOptions && (
          <>
            <Tooltip title={ADD_TO_GROUPS}>
              <IconButton
                aria-label="Add to Groups"
                component="span"
                color="inherit"
                size="small"
                onClick={() => handleAddToGroupsClick()}
                classes={{ colorInherit: classes.actions }}
              >
                <NRGroupIcon />
                <Typography variant={'subtitle2'} color={theme.palette.secondary.contrastText} sx={{ ml: 1, mr: 1 }}>
                  Add to Groups
                </Typography>
              </IconButton>
            </Tooltip>
            <Tooltip title={REMOVE_FROM_GROUPS}>
              <IconButton
                aria-label="Remove from Groups"
                component="span"
                color="inherit"
                size="small"
                onClick={() => {
                  setSelectedAssets(rows.filter((e, index) => selectedItems.includes(index)));
                  setShowManageGroupsRemoveAllModal(true);
                }}
                classes={{ colorInherit: classes.actions }}
              >
                <NRRemoveGroupsIcon />
                <Typography variant={'subtitle2'} color={theme.palette.secondary.contrastText} sx={{ ml: 1, mr: 1 }}>
                  Remove from Groups
                </Typography>
              </IconButton>
            </Tooltip>
          </>
        )}
        {tab === SBOM_TAB && (
          <WithPermissions permission={CONSTANTS.PERMISSIONS.WRITE_IMGS}>
            <Tooltip title={'Remove Components'}>
              <IconButton
                aria-label="Remove Components"
                component="span"
                color="inherit"
                size="small"
                onClick={handleRemoveComponentsClick}
                classes={{ colorInherit: classes.actions }}
              >
                <NRRemoveGroupsIcon />
                <Typography variant={'subtitle2'} color={theme.palette.secondary.contrastText} sx={{ ml: 1, mr: 1 }}>
                  Remove Components
                </Typography>
              </IconButton>
            </Tooltip>
          </WithPermissions>
        )}
        <Tooltip title={TOOLTIP_COPY_CSV}>
          <IconButton
            aria-label="copy to csv"
            component="span"
            color="inherit"
            size="small"
            onClick={() => handleCopyCsvClick()}
            classes={{ colorInherit: classes.actions }}
          >
            <Copy />
            <Typography variant={'subtitle2'} color={theme.palette.secondary.contrastText} sx={{ ml: 1, mr: 1 }} children={TOOLTIP_COPY_CSV} />
          </IconButton>
        </Tooltip>
        <Tooltip title={TOOLTIP_UNSELECT}>
          <IconButton
            aria-label="unselect"
            component="span"
            color="inherit"
            size="small"
            onClick={() => {
              setSelection([]);
              setAllItems([]);
            }}
            classes={{ colorInherit: classes.actions }}
          >
            <X />
            <Typography variant={'subtitle2'} color={theme.palette.secondary.contrastText} sx={{ ml: 1 }}>
              Cancel
            </Typography>
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
}
export default CopyToClipboardBanner;
